/* eslint-disable react/forbid-prop-types */
import React from 'react';
import {
  Picker,
  Item,
  TextField,
  TextArea,
  NumberField,
} from '@adobe/react-spectrum';
import PropTypes from 'prop-types';

import systemFieldMapping from './systemfield.config.json';
import DateTime from '../DateTime';

import { Section, TimeSection } from './style';
import { getEstDateTime } from '../../../utils/utils';

import DynamicList from './dynamicList';

function SystemField(props) {
  const {
    field,
    values,
    handleChange,
    setDateObject,
    dateObject,
    handleDateChange,
    handleTimeChange,
  } = props;
  switch (systemFieldMapping[field]?.dataType) {
    case 'TEXT':
      return (
        <TextField
          name={systemFieldMapping[`${field}`].apiname}
          label={systemFieldMapping[`${field}`].label}
          value={values[systemFieldMapping[`${field}`].label]}
          onInput={event => {
            const {
              target: { name, value },
            } = event;
            handleChange(name, value);
          }}
          placeholder=""
          width="750px"
        />
      );
    case 'SLCT':
      return (
        <Section>
          {systemFieldMapping[`${field}`]?.parameterOptions ? (
            <Picker
              label={systemFieldMapping[`${field}`].label}
              items={systemFieldMapping[`${field}`].parameterOptions}
              onSelectionChange={selected =>
                handleChange(systemFieldMapping[`${field}`].apiname, selected)
              }
            >
              {item => <Item key={item.value}>{item.label}</Item>}
            </Picker>
          ) : (
            <DynamicList
              name={systemFieldMapping[`${field}`].apiname}
              label={systemFieldMapping[`${field}`].label}
              param={systemFieldMapping[`${field}`].param}
              paramValue={systemFieldMapping[`${field}`].paramValue}
              handleChange={handleChange}
            />
          )}
        </Section>
      );
    case 'TXTA':
      return (
        <TextArea
          name={systemFieldMapping[`${field}`].apiname}
          label={systemFieldMapping[`${field}`].label}
          value={values[systemFieldMapping[`${field}`].apiname]}
          onInput={event => {
            const {
              target: { name, value },
            } = event;
            handleChange(name, value);
          }}
          placeholder=""
          width="750px"
        />
      );
    case 'NUM':
      return (
        <NumberField
          label={systemFieldMapping[`${field}`].label || ''}
          onChange={value =>
            handleChange(systemFieldMapping[`${field}`].apiname, value)
          }
          defaultValue={100}
          minValue={0}
        />
      );
    case 'DTTM':
      return (
        <Section>
          <span>
            <DateTime
              name={systemFieldMapping[`${field}`].apiname}
              label={systemFieldMapping[`${field}`].label}
              onChange={date => {
                setDateObject({
                  ...dateObject,
                  [systemFieldMapping[`${field}`].apiname]: date,
                });
                handleDateChange(
                  systemFieldMapping[`${field}`].apiname,
                  getEstDateTime(date),
                );
              }}
              value={
                dateObject[systemFieldMapping[`${field}`].apiname] || new Date()
              }
              selected={
                dateObject[systemFieldMapping[`${field}`].apiname] || new Date()
              }
              placeholderText="MM/DD/YYY"
            />
          </span>
          <TimeSection>
            <DateTime
              name={`${systemFieldMapping[`${field}`].apiname}Time`}
              label=" "
              selected={
                dateObject[`${systemFieldMapping[`${field}`].apiname}Time`] ||
                new Date()
              }
              onChange={date => {
                setDateObject({
                  ...dateObject,
                  [`${systemFieldMapping[`${field}`].apiname}Time`]: date,
                });
                handleTimeChange(
                  `${systemFieldMapping[`${field}`].apiname}`,
                  getEstDateTime(date),
                );
              }}
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={5}
              timeCaption="Time"
              dateFormat="h:mm aa"
            />
          </TimeSection>
        </Section>
      );
    default:
      return '';
  }
}

SystemField.propTypes = {
  field: PropTypes.string,
  values: PropTypes.object,
  handleChange: PropTypes.func,
  setDateObject: PropTypes.func,
  dateObject: PropTypes.object,
  handleDateChange: PropTypes.func,
  handleTimeChange: PropTypes.func,
};

SystemField.defaultProps = {
  field: '',
  values: {},
  handleChange: () => {},
  setDateObject: () => {},
  dateObject: {},
  handleDateChange: () => {},
  handleTimeChange: () => {},
};

export default SystemField;
